defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/ViewPlayCoupon',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/CouponHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/PlayersList',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/DrawsList',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/DeletePlayModal'
  ],
  function (m, Params, CtaButton, CardContent, CouponHeader, PlayersList, DrawsList, DeletePlayModal) {

    // View:
    var ViewPlayCoupon = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.dictionary = this.rootDictionary.get.bind({ prefix: 'ViewCoupon/' });

        this.deletingPlay = m.prop(false);
        this.playId = m.prop(Params.extract('spilId'));
        this.subscriptionGroupGameId = m.prop(Params.extract('subscriptionGroupGameId'));
        this.play = this.subscriptionGroupGameId() ? this.clubModel().getPlayBySubscriptionGroupGameId(this.subscriptionGroupGameId()) : this.clubModel().getPlayById(this.playId());

        if (!this.play) {
          return this.error(this.rootDictionary.get('ErrorMessages/GENERIC_ERROR'));
        }

        this.playParams = `?klubId=${this.clubId()}`;
        if (this.subscriptionGroupGameId()) {
          this.playParams += `&subscriptionGroupGameId=${this.play.subscriptionGroupGameId}`;
        } else {
          this.playParams += `&spilId=${this.play.groupPlayId}`;
        }

        this.showDeletePlayModal = () => {
          this.modal.setContent(m(DeletePlayModal, {
            controller: this,
            template: this.modal.defaultContentTemplate
          }));
          this.modal.show();
        };

        this.hasParticipatingPlayers = this.play.playerFundingSummaries.length > 0;
        const isCurrentUserPlayCreator = this.currentUser().customerId === this.play.creatorPlayerId;
        this.showDeleteButton = (this.isCurrentUserChairman() || isCurrentUserPlayCreator) && !this.hasParticipatingPlayers;
      },
      view: function (controller) {
        const $content = () => {
          if (!controller.play) {
            return;
          }
          return [
            m(CouponHeader, { controller: controller }),
            m('.play-together-coupon__title', [
              m('strong', controller.dictionary('PlayersSection/Title', { count: controller.play.playerFundingDetails.length }))
            ]),
            m(PlayersList, { controller: controller }),
            // Draws list
            m('.play-together-coupon__title', [
              m('strong', controller.dictionary('DrawsSection/Title', { count: controller.play.draws.length }))
            ]),
            m(DrawsList, { controller: controller }),
            m('.play-together-coupon__footer',
              controller.showDeleteButton ? CtaButton({
                text: controller.dictionary('DeletePlayButton'),
                onClick: controller.showDeletePlayModal,
                loading: controller.deletingPlay(),
                options: ['red']
              }) : CtaButton({
                text: controller.dictionary('GoToClubCouponsButton'),
                href: `${controller.navigationPaths.clubCouponsPage}?klubId=${controller.clubId()}`,
                options: ['primary']
              })
            )
          ];
        };

        const $footer = () => {
          if (!controller.play) {
            return;
          }
          return controller.play.mySummary.rowCount === 0 ?
            CtaButton({
              text: controller.dictionary('BuyInButton'),
              href: controller.navigationPaths.buyInPage + controller.playParams,
              options: ['primary']
            }) : null;
        };
        // View:
        return CardContent({
          className: 'play-together-coupon',
          $content: $content(),
          $footer: $footer()
        });
      }
    };

    // Public functions:
    return ViewPlayCoupon;
  });
